import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_ContextRule } from './ModuleFE_ContextRule.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const Props_DropDown = {
    module: ModuleFE_ContextRule,
    modules: [ModuleFE_ContextRule],
    mapper: item => [item.label],
    placeholder: 'Choose a context rule',
    caret: DropDown_DefaultCaret,
    renderer: item => _jsxs("div", { className: "ll_h_c", children: [" ", item.label, " "] })
};
export const DropDown_ContextRule = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_ContextRule,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete, className: 'ts-icon__small' }), item.label] });
    },
    uiSelector: DropDown_ContextRule.selectable,
});
export const MultiSelect_ContextRule = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map